<article class="content">
  <h1>{{ title }}</h1>
  <p>
    {{ message }}
  </p>
</article>
